export default "__VITE_ASSET__DPExj3r5__"